module.exports = __webpack_public_path__ + "static/the-lancashire-hotpots-icon-fb401485738db8b86b0ee2e4dba9e453.png";